function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 444.163 444.163"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.163 314.882-184 49.2c-17.2 4.4-34.8-5.6-39.2-22.8l-56-208.8c-4.4-17.2 5.6-34.8 22.8-39.2l46.8-12.8z",
    style: {
      fill: "#caf1ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.163 26.882c17.6 0 32 14.4 32 32v224c0 17.6-14.4 32-32 32h-288c-17.6 0-32-14.4-32-32v-224c0-17.6 14.4-32 32-32z",
    style: {
      fill: "#9ce0ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.163 191.682-47.6-47.6c-3.2-3.2-8-3.2-11.2 0l-96.8 95.2-60-56.4-119.2 126.8h336z",
    style: {
      fill: "#80d440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.363 235.682-52.4-50.4c-3.2-3.2-8-3.2-11.2 0l-123.6 121.6h120z",
    style: {
      fill: "#62c418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.163 290.882c-2 0-4-.8-5.6-2.4-3.2-3.2-3.2-8 0-11.2l8-8c3.2-3.2 8-3.2 11.2 0s3.2 8 0 11.2l-8 8c-1.6 1.6-3.6 2.4-5.6 2.4M94.563 303.682l-11.2-11.6 115.6-113.2c3.2-3.2 7.2-4.8 11.2-4.8s8 1.6 11.2 4.8l46.4 46.4-11.2 11.2-46.4-46.4z",
    style: {
      fill: "#5f961d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.963 265.682c-2 0-4-.8-5.6-2.4-3.2-3.2-3.2-8 0-11.2l118.4-117.6c6-6 16.4-6 22.4 0l47.6 47.6c3.2 3.2 3.2 8 0 11.2s-8 3.2-11.2 0l-47.6-47.6-118.4 117.6c-1.6 1.6-3.6 2.4-5.6 2.4",
    style: {
      fill: "#5f971d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.163 322.882h-288c-22 0-40-18-40-40v-224c0-22 18-40 40-40h288c22 0 40 18 40 40v224c0 22-18 40-40 40m-288-288c-13.2 0-24 10.8-24 24v224c0 13.2 10.8 24 24 24h288c13.2 0 24-10.8 24-24v-224c0-13.2-10.8-24-24-24z",
    style: {
      fill: "#62a2dd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.163,
    cy: 106.882,
    r: 24,
    style: {
      fill: "#ffe53c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 130.882c13.2 0 24-10.8 24-24s-10.8-24-24-24z",
    style: {
      fill: "#f3d933"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 138.882c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32m0-48c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16",
    style: {
      fill: "#c39215"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.763 373.282c-7.2 0-14-2-20-5.6-9.2-5.2-16-14-18.4-24.4l-56-208.8c-2.8-10.4-1.2-21.2 4-30.4s14-16 24.4-18.4l46.8-12.8 4.4 15.6-47.2 12.4c-6.4 1.6-11.6 5.6-14.8 11.2s-4 12-2.4 18.4l56 208.8c1.6 6.4 5.6 11.6 11.2 14.8s12 4 18.4 2.4l184-49.2 4 15.6-184 49.2c-3.2.8-6.8 1.2-10.4 1.2",
    style: {
      fill: "#62a2dd"
    }
  })));
};
export default SvgImage;